import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

@Component({
    selector: 'app-terminos-condiciones',
    templateUrl: './terminos-condiciones.component.html',
    styleUrls: ['./terminos-condiciones.component.css'],
    standalone: false
})
export class TerminosCondicionesComponent {
  loading: boolean = false;
  idPerfil: number = 2;
  perfil: string = '';

  constructor(private router: Router,
              private route: ActivatedRoute,
              private _location: Location) {
  }

  ngOnInit() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      document.documentElement.scrollTop = 0;
      const idParam = params.get("idPerfil");
      this.idPerfil = idParam ? Number.parseInt(idParam) : 2; // Conversión a número

      switch (this.idPerfil) {
        case 2:
          this.perfil = "Usuario";
          break;
        case 3:
          this.perfil = "Prestador";
          break;
        case 4:
          this.perfil = "Comercio";
          break;
        default:
          this.perfil = "Usuario";
          this.idPerfil = 2; // Establece un valor por defecto si no coincide
      }
    });
  }

  back() {
    this._location.back();
  }
}
